import React,{useState, useEffect} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle, EntryAuditInfo} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import { formatDateOnly } from '../../../common/functions';
import Grid from "@material-ui/core/Grid";
import { MaterialTable } from '../../../components';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableBody';
import {useGlobalState} from '../../../state';
import DescriptionIcon from '@material-ui/icons/Description';
import PaymentIcon from '@material-ui/icons/Payment';
import { MaterialTypeId } from '../../../common/enums';
import { findMaterialByTypeId } from '../utils/functions';
import DialogActions from '@material-ui/core/DialogActions';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PPMobileCardView from '../../../components/PPMobileCardView';

const useStyles = makeStyles(theme => ({
    fields: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    totalTable: {
        float: 'right',
        width: theme.spacing(28.6)
    },
    totalCell: {
        width: theme.spacing(16.25),
        paddingLeft: theme.spacing(0)
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    deleteButton: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
    },
}));

const SaleDetails = ({ data,trucks,lineSales, handleSaleDetailsDialogClose, showSaleDetailsDialog, onPaymentEdit, onSaleEdit, onGenerateInvoice, onDelete }) => {
    console.log("42", JSON.stringify(data));
    const classes = useStyles();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const [{user}] = useGlobalState();
    // Staff can only change sales created today
    const canModify = !(data && user.role === "STAFF" && !moment(data.createTime).isSame(moment(), "date"));
    // Read-only instead of disabled so the values stay readable
    const readOnly = { readOnly: true };
    const [quantityColumn, setQuantityColumn] = useState([])
    const [freeEggsColumn, setFreeEggsColumn] = useState([])

    const [billValue, setBillValue] = useState(0)
    const [tdsValue, setTdsValue] = useState(0)
    const [tcsValue, setTcsValue] = useState(0)
    const [gstValue, setGstValue] = useState(0)
    const [linesale,setLineCheck] = useState(false)

    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }
    /*const [billValueSum, setBillValueSum] = useState(0.0)

    function calculateBillTotal() {
        let total = 0.0
        let billValue = 0.0
        if(data !== undefined && data !== null && data.saleMaterials !== undefined && data.saleMaterials !== null){
            data.saleMaterials.forEach((saleMaterial,index)=>{
                billValue = (saleMaterial.quantity * saleMaterial.costPerUnit)
                total = total + billValue
            })
        }
        setBillValueSum(total)
    }
    useEffect(calculateBillTotal, [data]);*/

    function calculateTotalOfSaleMaterial(data){
        let billAmt = 0
        let tdsAmt = 0
        let tcsAmt = 0
        let gstAmt = 0
        let saleMaterials = data.saleMaterials 
        if(saleMaterials !== undefined){
            saleMaterials.forEach((saleMaterial) => {
                billAmt += saleMaterial.billValue
                let  commissionAmount  = 0.0
                if (saleMaterial.commissionPerUnit > 0) {
                    commissionAmount = (saleMaterial.quantity) * (saleMaterial.commissionPerUnit);
                }
                let taxableTotal  = saleMaterial.billValue - commissionAmount
                let tdsTaxAmt = taxableTotal * ((data.tds ? data.tds : 0)) / 100
                let tcsTaxAmt = taxableTotal * ((data.tcs ? data.tcs : 0)) / 100
                let gstTaxAmt = taxableTotal * ((saleMaterial.gst ? saleMaterial.gst : 0)) / 100
                tdsAmt += tdsTaxAmt
                tcsAmt += tcsTaxAmt
                gstAmt += gstTaxAmt
            })
        }

        setBillValue(billAmt)
        setTdsValue(tdsAmt)
        setTcsValue(tcsAmt)
        setGstValue(gstAmt)
    }
    useEffect(()=>{
        if (data?.onLineSale === 1) {
            setLineCheck(true)
            let truckName = trucks?.find(truck => truck.id === data?.truckID)
            let linesaleName = lineSales?.find(lineSale => lineSale.id === data?.lineSaleID)
            data.truckName = truckName?.number
            data.lineSaleName = linesaleName?.name
        } else {
            setLineCheck(false)
        }
        let isBird = findMaterialByTypeId(data?.saleMaterials, MaterialTypeId['BIRDS']);

        if(isBird){
            setQuantityColumn([
                {
                    title: 'Number Of Birds', field: 'numberOfBirds', editable: 'numberOfBirds',
                    render: (rowData) => {
                        return <span>{ rowData.materialTypeId === 7 ? rowData.numberOfBirds : 0 } </span>
                    }
                }
            ])
        }else{
            setQuantityColumn([])
        }
        
        let isEgg = findMaterialByTypeId(data?.saleMaterials, MaterialTypeId['EGGS']);
        if(isEgg){
            setFreeEggsColumn([
                {
                    title: 'Free Eggs', field: 'freeEggs', editable: 'never',
                    render: (rowData) => {
                        return <span>
                                {(rowData.materialTypeId === MaterialTypeId['EGGS'] && rowData.freeEggs !== "" && rowData.freeEggs !== undefined && rowData.freeEggs !== null)
                                    ? rowData.freeEggs 
                                    : 0} 
                               </span>
                    }
                }
            ])
        }else{
            setFreeEggsColumn([])
        }

        if (data && data.saleMaterials && Array.isArray(data.saleMaterials) && (data.saleMaterials).length > 0) {
            calculateTotalOfSaleMaterial(data)
        }
    }, [data,trucks,lineSales])

    return data ? <Dialog maxWidth='md' open={showSaleDetailsDialog} onClose={handleSaleDetailsDialogClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog- title"   >Sale Details
        {handleSaleDetailsDialogClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleSaleDetailsDialogClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
        <DialogContent dividers>
            <div className={`grid-container ${classes.fields}`}>
                <TextField label="Date" value={formatDateOnly(data.date, "DD/MM/YYYY")} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} />
                <TextField label="Invoice Number" value={data.invoiceNumber || ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} />
                <TextField label="Payment Due (in Days)" value={data.paymentDueDate || ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} />
                {!linesale ?
                    <TextField select label="Customer Name" value={data.customerName ? 0 : ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}}>
                        <MenuItem value={0}>{data.customerName}</MenuItem>
                    </TextField> :
                    <TextField select label="Line Name" value={data?.lineSaleName ? 0 : ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}}>
                        <MenuItem value={0}>{data?.lineSaleName}</MenuItem>
                    </TextField>
                }
                {!linesale ?
                    <TextField label="Truck Number" value={data.truckNumber || ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} /> :
                    <TextField select label="Truck" value={data?.truckName ? 0 : ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}}>
                        <MenuItem value={0}>{data?.truckName}</MenuItem>
                    </TextField>
                }
            </div>
            <Grid>
                {/* pp-dialog-card-table: mobile cards sit on the white dialog instead of the grey table background */}
                <div className="pp-dialog-card-table">
                <MaterialTable
                    columns={[
                        { title: 'id', field: 'id', hidden: true },
                        {
                            hidden: isDesktop,
                            // Same values as the desktop columns
                            render: rowData => <PPMobileCardView
                                title={rowData.materialName}
                                rows={[
                                    { label: 'Inventory Type', value: rowData.inventoryType === 1 ? 'Feed Mill' : (rowData.farmName.String + ' (' + rowData.shedName.String + ')'), fullWidth: true },
                                    { label: 'Quantity', value: rowData.quantity + " (In " + rowData.materialUnit + ")" },
                                    ...(quantityColumn.length > 0 ? [{ label: 'Number Of Birds', value: rowData.materialTypeId === 7 ? rowData.numberOfBirds : 0 }] : []),
                                    { label: 'Sale Price', value: rowData.costPerUnit },
                                    { label: 'Discount Per Unit', value: rowData.discountPerUnit },
                                    ...(freeEggsColumn.length > 0 ? [{ label: 'Free Eggs', value: (rowData.materialTypeId === MaterialTypeId['EGGS'] && rowData.freeEggs !== "" && rowData.freeEggs !== undefined && rowData.freeEggs !== null) ? rowData.freeEggs : 0 }] : []),
                                    { label: 'Bill Value', value: (rowData.billValue).toLocaleString(user.locales,amountObj), bold: true },
                                    { label: 'GST', value: (((rowData.gst || 0)/100) * rowData.billValue).toLocaleString(user.locales,amountObj) },
                                ]}
                            />
                        },
                        { title: 'Item Name', field: 'materialName', editable: 'never', hidden: !isDesktop },
                        {
                            title: 'Inventory Type', field: 'inventoryType', editable: 'never', hidden: !isDesktop,
                            render: (rowData) => {
                                return <span>{rowData.inventoryType === 1 ? 'Feed Mill' : 
                                (rowData.farmName.String + ' (' + rowData.shedName.String + ')')}</span>
                            }
                        },
                        {
                            title: 'Quantity', field: 'quantity', editable: 'never', hidden: !isDesktop,
                            render: (rowData) => {
                                return <span>{rowData.quantity + " (In " + rowData.materialUnit + ")"}</span>
                            }
                        },
                        ...quantityColumn.map(column => ({ ...column, hidden: !isDesktop })),
                        { title: 'Sale Price', field: 'costPerUnit', editable: 'never', hidden: !isDesktop },
                        { title: 'Discount Per Unit', field: 'discountPerUnit', editable: 'never', hidden: !isDesktop },
                        ...freeEggsColumn.map(column => ({ ...column, hidden: !isDesktop })),
                        {
                            title: 'Bill Value', field: 'billValue', editable: 'never', hidden: !isDesktop,
                            render: (rowData) => {
                                return <span>{(rowData.billValue).toLocaleString(user.locales,amountObj)}</span>
                            },
                        },
                        { title: 'GST', field: 'gst', editable: 'never', hidden: !isDesktop,
                          render: (rowData) => {
                            let gstTaxAmt = ((rowData.gst || 0)/100) * rowData.billValue
                            return <span>{gstTaxAmt.toLocaleString(user.locales,amountObj) }</span>
                         }
                        },
                    ]}
                    data={data.saleMaterials || []}
                   
                    options={{
                        actionsColumnIndex: -1,
                        search: false,
                        showTitle: false,
                        
                        toolbar: false,
                        header: isDesktop,
                        paging: false
                    }}
                />
                </div>
                <Table className={classes.totalTable} >
                    <TableHead>

                        <TableRow>
                            <TableCell className={classes.totalCell}>Bill Value</TableCell>
                            <TableCell>{(billValue).toLocaleString(user.locales,amountObj)}</TableCell>
                        </TableRow>
                        {/* commenting for now */}
                        {gstValue && gstValue > 0 ? 
                            <TableRow>
                            <TableCell className={classes.totalCell}>GST</TableCell>
                            <TableCell>{(gstValue).toLocaleString(user.locales,amountObj)}</TableCell>
                        </TableRow>
                        : null}
                        {tdsValue && tdsValue > 0 ? <TableRow>
                            <TableCell className={classes.totalCell}>TDS </TableCell>
                            <TableCell>{(tdsValue).toLocaleString(user.locales,amountObj)}</TableCell>
                        </TableRow> : null}
                        {tcsValue && tcsValue > 0 ? <TableRow>
                            <TableCell className={classes.totalCell}  >TCS </TableCell>
                            <TableCell>{(tcsValue).toLocaleString(user.locales,amountObj)}</TableCell>
                        </TableRow>: null}
                        
                        <TableRow>
                            <TableCell className={classes.totalCell} >Final Total </TableCell>
                            <TableCell>{(data.totalBillValue + tcsValue + gstValue - tdsValue).toLocaleString(user.locales,amountObj)}</TableCell>
                        </TableRow>
                        {/* commenting for now */}
                        {/* <TableRow>
                            <TableCell className={classes.totalCell}  >Total With TDS</TableCell>
                            <TableCell>{
                            data.totalBillValue === 0 ?
                            (0).toLocaleString(user.locales,amountObj): 
                            (data.totalBillValue+(((data.tds || 0)*data.totalBillValue)/100)).toLocaleString(user.locales,amountObj) 
                        }</TableCell>
                        </TableRow> */}
                    </TableHead>
                </Table>
            </Grid>
        </DialogContent>
        <DialogActions>
            <EntryAuditInfo entry={data}/>
            {/* <div className={classes.actions}> */}
                {canModify &&
                    <Button variant="outlined" color="primary" startIcon={<PaymentIcon />} onClick={() => onPaymentEdit(data)}>
                        Payment
                    </Button>
                }
                <Button variant="outlined" color="primary" startIcon={<DescriptionIcon />} onClick={() => onGenerateInvoice(data)}>
                    Invoice
                </Button>
                {canModify &&
                    <Button variant="contained" color="primary" startIcon={<EditIcon />} onClick={() => onSaleEdit(data)}>
                        Edit
                    </Button>
                }
                {canModify &&
                    <Button variant="outlined" className={classes.deleteButton} startIcon={<DeleteIcon />} onClick={() => onDelete(data)}>
                        Delete
                    </Button>
                }
            {/* </div> */}
        </DialogActions>
    </Dialog>
        : null
};

export default SaleDetails;